import { StoreSubject } from "@/lib/store/StoreSubject";

export type McpBridgeConnectionStatus =
  | "disconnected"
  | "connecting"
  | "connected"
  | "error";

export interface McpBridgeState {
  /** User preference: attempt to stay connected to the local MCP host. */
  enabled: boolean;
  status: McpBridgeConnectionStatus;
  sessionId?: string;
  lastError?: string;
}

export const mcpBridgeStore = {
  state: new StoreSubject<McpBridgeState>({
    enabled: false,
    status: "disconnected",
  }),

  getState(): McpBridgeState {
    return this.state.getValue();
  },

  patch(partial: Partial<McpBridgeState>): void {
    this.state.next({ ...this.state.getValue(), ...partial });
  },
};
